import "@master/normal.css";
import { StrictMode } from "react";

import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { initRuntime } from "@master/css";

import "@/styles/base.css";
import "@/plugins/dayjs";
import "@/plugins/i18n";
import { masterConfig } from "@/master.css";
import { store } from "@/stores";
import { AntdProvider } from "./AntdProvider";

initRuntime(masterConfig);

const render = () => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <Provider store={store}>
        <AntdProvider />
      </Provider>
    </StrictMode>
  );
};

render();
